import { all } from 'redux-saga/effects'
import watcherNotificationSaga from './RequestsHandlers/notificationRequestHandler'
import watcherServicesSaga from './RequestsHandlers/servicesRequestHandler'
import watcherProfileSaga from './RequestsHandlers/profileRequestHandler'
import watcherAuthSaga from './RequestsHandlers/authRequestHandler'
import watcherSecreterySaga from './RequestsHandlers/secreteryHandler'
import watcherCommonSaga from './RequestsHandlers/commonRequestHandler'
import watcherIVRRequestsSaga from './RequestsHandlers/ivrRequestHandler'
import watcherDocumentSaga from './RequestsHandlers/documentRequestHandler'
import watcherCallReportSaga from './RequestsHandlers/callReportRequestHandler'
import watcherLineSettingsSaga from './RequestsHandlers/lineSettingsHandler'
import watcherChargeSaga from './RequestsHandlers/chageRequestHandler'
import watcherCompanySaga from './RequestsHandlers/companyRequestHandler'
import purchaseSaga from './RequestsHandlers/purchaseRequestHandler'
import watcherTransactionSaga from './RequestsHandlers/transactionHandler'
import queueSaga from './RequestsHandlers/queueRequestHandler'
import customerAttachmentsSaga from './RequestsHandlers/customerAttachmentHandler'
import secretaryMessageSaga from './RequestsHandlers/secretaryMessageHandler'
import customerSaga from './RequestsHandlers/customerRequestHandler'
import authSagaWatcher from './RequestsHandlers/authRequestHandlers'
import faxSaga from './RequestsHandlers/faxRequestHandler'
import callQueueReportSaga from './RequestsHandlers/callQueueReportHandler'
import voiceMailSaga from './RequestsHandlers/voiceMailRequestHandler'
import contactSaga from './RequestsHandlers/contactRequestHandler'
import ticketSaga from './RequestsHandlers/ticketRequestHandler'
import dashboardSaga from './RequestsHandlers/dashboardRequestHandler'
import CalendarHolidaySaga from './RequestsHandlers/calendarHolidayRequestHandler'
import outGoingSaga from './RequestsHandlers/outGoingRequestHandler'
import callRatingSaga from './RequestsHandlers/callRatingRequestHandler'
import outGoingCallOnsecretarySaga from './RequestsHandlers/outGoingCallOnSecretaryRequestHandler'


export default function* rootSaga() {
  yield all([
    watcherNotificationSaga(),
    watcherServicesSaga(),
    watcherProfileSaga(),
    watcherAuthSaga(),
    watcherSecreterySaga(),
    watcherCommonSaga(),
    watcherIVRRequestsSaga(),
    watcherDocumentSaga(),
    watcherCallReportSaga(),
    watcherLineSettingsSaga(),
    watcherCompanySaga(),
    watcherTransactionSaga(),
    watcherChargeSaga(),
    authSagaWatcher(),
    purchaseSaga(),
    queueSaga(),
    customerAttachmentsSaga(),
    secretaryMessageSaga(),
    customerSaga(),
    faxSaga(),
    callQueueReportSaga(),
    voiceMailSaga(),
    contactSaga(),
    ticketSaga(),
    dashboardSaga(),
    outGoingSaga(),
    CalendarHolidaySaga(),
    callRatingSaga(),
    outGoingCallOnsecretarySaga()
  ])
}
